// import React, { useEffect, useState } from "react";
// import ReactDOM from "react-dom/client";
// import Signin from "./Components/Signin";
// import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
// import Dashboard from "./Components/Dashboard";
// import ServicableArea from "./Components/Masters/ServicableArea";
// import ParentCategoryGroups from "./Components/Items/ParentCategoryGroups";
// import ParentCategory from "./Components/Items/ParentCategory";
// import ChildCategory from "./Components/Items/ChildCategory";
// import Testing from "./Components/Items/Testing";
// import HeroSlider from "./Components/Appearance/HeroSlider";
// import Offers4U from "./Components/Appearance/Offers4U";
// import ServiceGroups from "./Components/Items/ServiceGroups";
// import ServiceType from "./Components/Items/ServiceType";
// import AllService from "./Components/Items/services/AllService";
// import AllPackage from "./Components/Items/packages/AllPackages";
// import EditPackage from "./Components/Items/packages/EditPackage";
// import NewPackage from "./Components/Items/packages/NewPackage";
// import HomeBanner from "./Components/Appearance/HomeBanner";
// import CoverImage from "./Components/Appearance/CoverImage";
// import ParentSlider from "./Components/Appearance/ParentSlider";
// import Serviceshortcut from "./Components/Appearance/Serviceshortcut";
// import VideoShortcut from "./Components/Appearance/VideoShortcut";
// import Testimonial from "./Components/Appearance/Testimonial";
// import BrandweUse from "./Components/Appearance/BrandWeuse";
// import FaqQuestion from "./Components/Appearance/Faq";
// import NewService from "./Components/Items/services/NewService";
// import EditService from "./Components/Items/services/EditService";
// import Coupons from "./Components/Masters/coupons/Coupons";
// import Addcoupons from "./Components/Masters/coupons/Addcoupons";
// import Editcoupons from "./Components/Masters/coupons/Edit-coupons";
// import SlotPage from "./Components/Masters/Slot";
// import TodaysJob from "./Components/TodaysJob/TodayJobs";
// import EditJob from "./Components/EditJob";
// import UpcomingJob from "./Components/UpcomingJob";
// import CanceledJob from "./Components/CanceledJob";
// import EscalationJob from "./Components/EscalationJob";
// import CreateJob from "./Components/CreateJob";
// import JobDetails from "./Components/TodaysJob/JobDetails";
// import ServiceProvider from "./Components/ServicePeovider/ServiceProvider";
// import Newprovider from "./Components/ServicePeovider/Newprovider";
// import Editprovider from "./Components/ServicePeovider/EditProvider";
// import DuplicateJob from "./Components/DuplicateJob";
// import OtherCharges from "./Components/Appearance/OtherCharges";
// import ServiceShortcutHeading from "./Components/Appearance/ServiceShortcutHeading";
// import Header from "./Components/Header/Header";
// import Costumers from "./Components/Masters/Costumers/Costumers";
// import Inquiry from "./Components/Inquiryform/Inquiry";

// export default function App() {
//   const [userData, setUserData] = useState();
//   const user = localStorage.getItem("user");
//   const location = useLocation(); // Use useLocation to get the current route
//   useEffect(() => {
//     if (user) {
//       setUserData(JSON.parse(user));
//     }
//   }, []);

//   return (
//     <>
//       <BrowserRouter basename="/">
//         {location.pathname !== "/" && <Header userData={userData} />}
//         <Routes>
//           <Route path="/" element={<Signin />} />
//           <Route
//             path="/dashboard"
//             element={<Dashboard userData={userData} />}
//           />
//           <Route path="/servicablearea" element={<ServicableArea />} />
//           <Route
//             path="/parentCategoryGroup"
//             element={<ParentCategoryGroups />}
//           />
//           <Route path="/parentCategory" element={<ParentCategory />} />
//           <Route path="/ChildCategory" element={<ChildCategory />} />
//           <Route path="/HeroSlider" element={<HeroSlider />} />
//           <Route path="/Coverimage" element={<CoverImage />} />
//           <Route path="/offers4u" element={<Offers4U />} />
//           <Route path="/servicegroup" element={<ServiceGroups />} />
//           <Route path="/servicetype" element={<ServiceType />} />
//           <Route path="/servicetype" element={<ServiceType />} />
//           <Route path="/service" element={<AllService />} />
//           <Route path="/service/new" element={<NewService />} />
//           <Route path="/service/edit" element={<EditService />} />
//           <Route path="/slot" element={<SlotPage />} />
//           <Route path="/costumers" element={<Costumers />} />

//           <Route path="/package" element={<AllPackage />} />
//           <Route path="/Homebanner" element={<HomeBanner />} />
//           <Route path="/parentSlider" element={<ParentSlider />} />
//           <Route path="/serviceShortcut" element={<Serviceshortcut />} />
//           <Route path="/videoShortcut" element={<VideoShortcut />} />
//           <Route path="/testimonial" element={<Testimonial />} />
//           <Route path="/branduse" element={<BrandweUse />} />
//           <Route path="/faqQuestion" element={<FaqQuestion />} />
//           <Route path="/package/new" element={<NewPackage />} />
//           <Route path="/package/edit" element={<EditPackage />} />
//           <Route path="/coupons" element={<Coupons />} />
//           <Route path="/addcoupons" element={<Addcoupons />} />
//           <Route path="/otherchages" element={<OtherCharges />} />
//           <Route path="/editcoupons" element={<Editcoupons />} />
//           <Route path="/todaysjob" element={<TodaysJob />} />
//           <Route
//             path="/ServiceShortcutHeading"
//             element={<ServiceShortcutHeading />}
//           />
//           <Route path="/jobDetails/:data" element={<JobDetails />} />
//           <Route path="/editjob/:data" element={<EditJob />} />
//           <Route path="/duplicatejob/:data" element={<DuplicateJob />} />
//           <Route path="/upcomingjob" element={<UpcomingJob />} />
//           <Route path="/canceledjob" element={<CanceledJob />} />
//           <Route path="/escalationjob" element={<EscalationJob />} />
//           <Route path="/createjob" element={<CreateJob />} />
//           <Route path="/serviceProvider" element={<ServiceProvider />} />
//           <Route path="/newprovider" element={<Newprovider />} />
//           <Route path="/editprovider" element={<Editprovider />} />
//           <Route path="/inquiry" element={<Inquiry />} />
//           <Route path="/testing" element={<Testing />} />
//         </Routes>
//       </BrowserRouter>
//     </>
//   );
// }
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom"; // Move useLocation inside the BrowserRouter
import Signin from "./Components/Signin";
import Dashboard from "./Components/Dashboard";
import ServicableArea from "./Components/Masters/ServicableArea";
import ParentCategoryGroups from "./Components/Items/ParentCategoryGroups";
import ParentCategory from "./Components/Items/ParentCategory";
import ChildCategory from "./Components/Items/ChildCategory";
import Testing from "./Components/Items/Testing";
import HeroSlider from "./Components/Appearance/HeroSlider";
import Offers4U from "./Components/Appearance/Offers4U";
import ServiceGroups from "./Components/Items/ServiceGroups";
import ServiceType from "./Components/Items/ServiceType";
import AllService from "./Components/Items/services/AllService";
import AllPackage from "./Components/Items/packages/AllPackages";
import EditPackage from "./Components/Items/packages/EditPackage";
import NewPackage from "./Components/Items/packages/NewPackage";
import HomeBanner from "./Components/Appearance/HomeBanner";
import CoverImage from "./Components/Appearance/CoverImage";
import ParentSlider from "./Components/Appearance/ParentSlider";
import Serviceshortcut from "./Components/Appearance/Serviceshortcut";
import VideoShortcut from "./Components/Appearance/VideoShortcut";
import Testimonial from "./Components/Appearance/Testimonial";
import BrandweUse from "./Components/Appearance/BrandWeuse";
import FaqQuestion from "./Components/Appearance/Faq";
import NewService from "./Components/Items/services/NewService";
import EditService from "./Components/Items/services/EditService";
import Coupons from "./Components/Masters/coupons/Coupons";
import Addcoupons from "./Components/Masters/coupons/Addcoupons";
import Editcoupons from "./Components/Masters/coupons/Edit-coupons";
import SlotPage from "./Components/Masters/Slot";
import TodaysJob from "./Components/TodaysJob/TodayJobs";
import EditJob from "./Components/EditJob";
import UpcomingJob from "./Components/UpcomingJob";
import CanceledJob from "./Components/CanceledJob";
import EscalationJob from "./Components/EscalationJob";
import CreateJob from "./Components/CreateJob";
import CreateLeadJob from "./Components/CreateLeadJob";
import JobDetails from "./Components/TodaysJob/JobDetails";
import ServiceProvider from "./Components/ServicePeovider/ServiceProvider";
import Newprovider from "./Components/ServicePeovider/Newprovider";
import Editprovider from "./Components/ServicePeovider/EditProvider";
import DuplicateJob from "./Components/DuplicateJob";
import OtherCharges from "./Components/Appearance/OtherCharges";
import ServiceShortcutHeading from "./Components/Appearance/ServiceShortcutHeading";
import Header from "./Components/Header/Header";
import Costumers from "./Components/Masters/Costumers/Costumers";
import Inquiry from "./Components/Inquiryform/Inquiry";
import Paymentgateway from "./Components/Paymentgateway/Paymentgateway";
import Placeholderimage from "./Components/Placeholderimage/Placeholderimage";
import Packagediscount from "./Components/Packagediscount/Packagediscount";
import Notification from "./Components/Notification/Notification";
import PageAdd from "./Components/PageAdd/PageAdd";
import Deleteaccount from "./Components/Deleteaccount/Deleteaccount";
import SpMessage from "./Components/SpMessage/SpMessage";
import Leaves from "./Components/Leaves/Leaves";
import AllLeve from "./Components/AllLeve/AllLeve";
import GetPenaltyData from "./Components/GetAllPelenty/GetPenaltyData";
import AddIdCard from "./Components/AddIdCard/AddIdCard";
import TodayJobsnew from "./Components/TodaysJob/TodayJobsnew";
import Wallet from "./Components/Wallet/Wallet";
import Viewwallet from "./Components/Wallet/Viewwallet";
import Leadgeneration from "./Components/Leadgeneration/Leadgeneration";
import Walletfundrules from "./Components/Walletfundrules"
import Cashback from "./Components/Cashback/index";
import CashbackAdd from "./Components/Cashback/CashbackAdd";
import Appversion from "./Components/Appversion/index";
import ProfessionalPreference from "./Components/ProfessionalPreference";
import Penalty from "./Components/Penalty/Penalty";
import PenaltySp from "./Components/Penalty/PenaltySp";
import Spcashbackrules from "./Components/Spcashbackrules/Spcashbackrules";
import Apkupload from "./Components/Apkupload/Apkupload";
import ChangePassword from "./Components/ChangePassword";

function App() {
  const [userData, setUserData] = useState();
  const user = localStorage.getItem("user");

  useEffect(() => {
    if (user) {
      setUserData(JSON.parse(user));
    }
  }, []);

  return (
    <BrowserRouter basename="/">
      <AppContent userData={userData} />
    </BrowserRouter>
  );
}

function AppContent({ userData }) {
  const location = useLocation(); // Now useLocation is used within BrowserRouter context

  return (
    <>
      {/* Conditionally render the Header based on the current path */}
      {location.pathname !== "/" && <Header userData={userData} />}
      <Routes>
        <Route path="/" element={<Signin />} />
        <Route path="/dashboard" element={<Dashboard userData={userData} />} />
        <Route path="/PageAdd" element={<PageAdd />} />
        <Route path="/wallet-fund-rules" element={<Walletfundrules />} />

        <Route path="/delete-account" element={<Deleteaccount />} />
        <Route path="/appversion" element={<Appversion />} />
        <Route
          path="/professional-preference"
          element={<ProfessionalPreference />}
        />
        <Route path="/ServicableArea" element={<ServicableArea />} />
        <Route path="/paymentgateway" element={<Paymentgateway />} />
        <Route path="/add-id-card" element={<AddIdCard />} />
        <Route path="/placeholderimage" element={<Placeholderimage />} />
        <Route path="/parentCategoryGroup" element={<ParentCategoryGroups />} />
        <Route path="/Packagediscount" element={<Packagediscount />} />
        <Route path="/parentCategory" element={<ParentCategory />} />
        <Route path="/ChildCategory" element={<ChildCategory />} />
        <Route path="/HeroSlider" element={<HeroSlider />} />
        <Route path="/Coverimage" element={<CoverImage />} />
        <Route path="/offers4u" element={<Offers4U />} />
        <Route path="/servicegroup" element={<ServiceGroups />} />
        <Route path="/servicetype" element={<ServiceType />} />
        <Route path="/service" element={<AllService />} />
        <Route path="/service/new" element={<NewService />} />
        <Route path="/service/edit" element={<EditService />} />
        <Route path="/slot" element={<SlotPage />} />
        <Route path="/allleaves" element={<AllLeve />} />
        <Route path="/getpenalty" element={<GetPenaltyData />} />
        <Route path="/penalty" element={<Penalty />} />
        <Route path="/penalty-sp/:id" element={<PenaltySp />} />
        <Route path="/sp-cashback-rules" element={<Spcashbackrules />} />
        <Route path="/costumers" element={<Costumers />} />
        <Route path="/Notification" element={<Notification />} />
        <Route path="/apk-upload" element={<Apkupload />} />
        <Route path="/cashback" element={<Cashback />} />
        <Route path="/cashback/edit/:id" element={<CashbackAdd />} />
        {/* <Route path="/todayjobsnew" element={<TodayJobsnew/>} /> */}
        <Route path="/package" element={<AllPackage />} />
        <Route path="/Homebanner" element={<HomeBanner />} />
        <Route path="/parentSlider" element={<ParentSlider />} />
        <Route path="/serviceShortcut" element={<Serviceshortcut />} />
        <Route path="/videoShortcut" element={<VideoShortcut />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/branduse" element={<BrandweUse />} />
        <Route path="/faqQuestion" element={<FaqQuestion />} />
        <Route path="/package/new" element={<NewPackage />} />
        <Route path="/package/edit" element={<EditPackage />} />
        <Route path="/coupons" element={<Coupons />} />
        <Route path="/cashback/add" element={<CashbackAdd />} />
        <Route path="/addcoupons" element={<Addcoupons />} />
        <Route path="/otherchages" element={<OtherCharges />} />
        <Route path="/editcoupons" element={<Editcoupons />} />
        <Route path="/todaysjob" element={<TodayJobsnew />} />
        <Route path="/sp-message" element={<SpMessage />} />
        <Route
          path="/ServiceShortcutHeading"
          element={<ServiceShortcutHeading />}
        />
        <Route path="/jobDetails/:data" element={<JobDetails />} />
        <Route path="/editjob/:data" element={<EditJob />} />
        <Route path="/duplicatejob/:data" element={<DuplicateJob />} />
        <Route path="/upcomingjob" element={<TodayJobsnew />} />
        <Route path="/upcomingjobold" element={<UpcomingJob />} />
        <Route path="/canceledjob" element={<CanceledJob />} />
        <Route path="/escalationjob" element={<EscalationJob />} />
        <Route path="/createjob" element={<CreateJob />} />
        <Route path="/createleadjob" element={<CreateLeadJob />} />
        <Route path="/serviceProvider" element={<ServiceProvider />} />
        <Route path="/newprovider" element={<Newprovider />} />
        <Route path="/editprovider" element={<Editprovider />} />
        <Route path="/inquiry" element={<Inquiry />} />
        <Route path="/testing" element={<Testing />} />
        <Route path="/leadgeneration" element={<Leadgeneration />} />
        <Route path="/TodayJobsold" element={<TodaysJob/>} />
        <Route path="/leaves/:phone" element={<Leaves />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/view-wallet/:id" element={<Viewwallet />} />
        <Route path="/change-password" element={<ChangePassword />} />
      </Routes>
    </>
  );
}

export default App;